module.exports = __webpack_public_path__ + "static/surf-park-staff-visual-b15554f798c00f38517dcf495eb44f8d.png";